import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import { useAuth } from "../context/AuthContext";
import { LegalNoticeDialog } from "../components/LegalNoticeDialog";
import { AppShell } from "./AppShell";
import { LoginPage } from "./LoginPage";

/**
 * The /legal deep link: the BFF no longer serves its own /legal page (the
 * notice is a modal now, LegalNoticeDialog), so this route falls through
 * to the SPA and opens the dialog itself, over the login page for an
 * anonymous visitor or over the authenticated shell for a signed-in one.
 * Not nested under RequireAuth on purpose: an anonymous visitor must
 * still be able to open it. Closing it (Close, Escape, or the backdrop)
 * navigates to /, which then applies the normal signed-in/signed-out
 * routing.
 */
export function LegalRoute() {
  const { status, me } = useAuth();
  const navigate = useNavigate();

  function handleClose() {
    navigate("/", { replace: true });
  }

  if (status === "loading") {
    return (
      <Stack sx={{ alignItems: "center", justifyContent: "center", height: "100vh" }}>
        <CircularProgress />
      </Stack>
    );
  }

  const authenticated = me !== null && me.kind !== "anon";

  return (
    <>
      {authenticated ? <AppShell /> : <LoginPage />}
      <LegalNoticeDialog open onClose={handleClose} />
    </>
  );
}
